<template>
  <div class="survey-logs">
    <div class="d-flex flex-row justify-content-between align-items-center p-1">
      <div class="mr-1 flex-grow-0">
        <b-img :src="log.userImage" style="width: 1.5rem; height:1.5rem;" class="rounded-circle"></b-img>
      </div>
      <div class="mx-1 flex-grow-1 text-left">
        <b-badge :variant="status === 'COMPLETE' ? 'success' : status === 'TERMINATE' ? 'danger' : status === 'QUOTA_OVER' ? 'warning' : 'secondary'" class="text-uppercase">{{status}}</b-badge>
      </div>
      <div class="ml-1 flex-grow-0">
        <small style="font-size: 0.7rem;">{{log.date}}</small>
      </div>
    </div>
    <div>
      <div class="mx-1 text-left">
        <router-link :to="`/project/progress/${log.surveyID}`">
          <small>{{log.title}}</small>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    log: {
      userName: String,
      userImage: String,
      vcID: String,
      title: String,
      surveyID: String,
      date: String,
      flag: String,
      status: String
    }
  },
  name: 'surveyJoinLog',
  created () {
  },
  computed: {
    status () {
      if (this.log.flag === 'start') return this.log.flag
      return this.log.status
    }
  }
}
</script>

<style scoped>
div.survey-logs {
  width: 50vw;
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/surveyJoinLog.vue